import { createNamespacedHelpers } from "vuex";
// Store
const {
  mapActions: mapActionsOfMonitoringVesselManeuvering,
  mapMutations: mapMutationsOfMonitoringVesselManeuvering,
  mapState: mapStateOfMonitoringVesselManeuvering,
  mapGetters: mapGettersOfMonitoringVesselManeuvering
} = createNamespacedHelpers("sdfMonitoringVesselManeuvering");


const _mapLayerIds = [
  "sdfTrafficRouteLineLayer",
  "sdfTrafficRouteFillLayer",
  "sdfTrafficRouteSymbolLayer",
  "sdfNavigationalAidsLayer",
  "sdfSeaRouteLineLayer",
  "sdfSeaRouteDottedLineLayer",
  "sdfSeaRoutePointLayer",
  "sdfSeaRouteTextLayer",
  "sdfOtherVesselPositionSymbolLayer",
  "sdfOtherVesselPositionTextLayer",
  "sdfMonitoringVesselTrackLineLayer",
  "sdfMonitoringVesselPositionCircleLayer",
  "sdfMonitoringVesselPositionLayer",
  "sdfPastGhostLayer",
  "sdfPastGhostTextLayer",
  "sdfCurrentGhostLayer",
  "sdfVirtualQuayLineLayer"
]

const _mapSourceIds = [
  "sdfNavigationalAidsSource",
  "sdfTrafficRouteSource",
  "sdfMonitoringVesselPositionSource",
  "sdfMonitoringVesselTrackSource",
  "sdfSeaRouteSource",
  "sdfSeaRouteSource",
  "sdfOtherVesselsPositionSource",
  "sdfCurrentGhostSymbolSource",
  "sdfPastGhostSymbolSource",
  "sdfVirtualQuaySymbolSource"
]

export default {
  data() {
    return {
      noneValue: "---",
      mapSourceIds: _mapSourceIds,
      mapLayerIds: _mapLayerIds
    };
  },
  computed: {
    ...mapStateOfMonitoringVesselManeuvering({
      channelDataManeuvering: state => state.channelDataManeuvering,
      channelDataEngine: state => state.channelDataEngine,
      channelDataAlert: state => state.channelDataAlert,
      abnormalMachinery: state => state.abnormalMachinery,
      seaRoutes: state => state.seaRoutes,
      veeringPoints: state => state.veeringPoints,
      isBerthMode: state => state.isBerthMode,
      arrivalPoint: state => state.arrivalPoint,
      isArrivedPoint: state => state.isArrivedPoint,
      isLessThan1kn: state => state.isLessThan1kn,
      trackPositions: state => state.trackPositions,
      latestDeparturePoint: state => state.latestDeparturePoint,
      nextArrivalPoint: state => state.nextArrivalPoint,
      otherVesselsPosition: state => state.otherVesselsPosition,
      ghostPositions: state => state.ghostPositions,
      jumpTo: state => state.jumpTo,
      connectingState4gVSAT: state => state.connectingState4gVSAT,
      connectingStateSBX: state => state.connectingStateSBX,
      connectingStateAMS: state => state.connectingStateAMS,
      initialFOFlowData: state => state.initialFOFlowData,
      foFlows: state => state.foFlows,
      foFlowsSum: state => state.foFlowsSum,
      trackHistories: state => state.trackHistories,
      isPositionsUpdatingByApi: state => state.isPositionsUpdatingByApi,
    }),
    ...mapGettersOfMonitoringVesselManeuvering([
      "isExistsChannelDataManeuvering",
      "getMonitoringVesselGeoPoint",
      "getMonitoringVesselInfo",
      "getMonitoringVesselPositionFeatureCollection",
      "getSeaRouteFeatureCollection",
      "getOtherVesselsPosition",
      "getTrackLineFeatureCollection",
      "getGhostPositionsFeatureCollection",
      "getCurrentGhostPositions",
      "getCurrentGhostGeoPoint",
      "getVirtualQuayFeatureCollection",
      "getSeaRouteInfo",
      "getPassingTime",
      "isSteadyOrInland",
      "idDepartureOrBerthing",
      "getAlertList",
      "getZoomLevelByOperationMode",
      "isGhosToBeUpdated",
      "junmpingGhostPosition",
    ])
  },
  methods: {
    ...mapActionsOfMonitoringVesselManeuvering([
      "subscribeSeaRoute",
      "subscribeEvent",
      "subscribeChannelDataManeuvering",
      "subscribeChannelDataEngine",
      "subscribeChannelDataAlert",
      "subscribeOtherVesselsPosition",
      "fetchOtherVesselsPosition",
      "unsubscribeFirestore",
      "resetStateOfMonitoringVesselManeuvering",
      "getInitialFOFlow",
      "setInitialFOFlow",
      "calcFOFlow",
      "setTrackHistoryPositions",
      "checkChannelDataManeuveringLastUpdate",
      "checkChannelDataEngineLastUpdate",
      "updateGhostPoistions",
    ]),
    ...mapMutationsOfMonitoringVesselManeuvering([
      "SET_CHANNEL_DATA_MANEUVERING",
      "SET_ABNORMAL_MACHINERY",
      "MERGE_TRACK_POSITIONS",
      "RESET_TRACK_POSITIONS",
      "MERGE_GHOST_POSITIONS",
      "RESET_GHOST_POSITIONS",
      "SET_OTHER_VESSELS_POSITION",
      "SET_IS_ARRIVED_POINT",
      "SET_NEXT_ARRIVAL_POINT",
      "SET_LATEST_DEPARTURE_POINT",
      "SET_EVENT_DATA",
      "SET_BERTH_MODE",
      "SET_JUMP_TO",
      "SET_CONNECTING_STATE_4G_VSAT",
      "SET_CONNECTING_STATE_SBX",
      "SET_CONNECTING_STATE_AMS",
      "UNSUBSCRIBE_FIRE_STORE",
      "SET_GHOST_MODE",
      "SET_TRACK_POSITIONS",
      "SET_TRACK_HISTORIES",
      "SET_GHOST_POSITIONS",
      "SET_IS_POSITIONS_UPDATING_BY_API",
      "SET_BEFORE_UPDATING_GHOST_BY_API_DATETIME",
    ])
  }
};
